import React from 'react';
import { TabbedInterface } from 'Permafrost/index';
/**
 * An a11y-friendly tabbed interface; allows the user to navigate between URLs.
 *
 * If the URL does **not** need to change between sections, the `TabbedContainer` component
 * should be used instead.
 */
export function TabNavigation(props) {
    const { children, className, currentTab, fullWidthTabs, id, tabs } = props;
    return (React.createElement(TabbedInterface, { tabType: "navigation", tabs: tabs, className: className, currentTab: currentTab, "data-cy": props['data-cy'], fullWidthTabs: fullWidthTabs, id: id }, children));
}
//# sourceMappingURL=TabNavigation.js.map